import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ZoomLoadStatus = 'loading' | 'ready' | 'error';

@Injectable({ providedIn: 'root' })
export class ZoomStatusService {
  private statusSubject = new BehaviorSubject<ZoomLoadStatus>('loading');
  public readonly status$ = this.statusSubject.asObservable();

  // 'ready' es final; 'error' puede pasar a 'ready' si Zoom termina respondiendo después del tiempo límite
  public setStatus(status: Exclude<ZoomLoadStatus, 'loading'>): void {
    if (this.statusSubject.value === 'ready') return;
    this.statusSubject.next(status);
  }
}
